<template>
  <div v-show="isActive" v-if="renderWhenNotActive || isActive">
    <!-- @slot The tab's content. -->
    <slot></slot>
  </div>
</template>

<script setup>

import { ref, watch, computed } from 'vue';

/**
 * A simple tab used in the EnTabView.
 *
 * @prop {String} title - The title of the tab.
 * @prop {Boolean} onlyRenderWhenActive - Specifies whether the tab is only rendered when active (true) or not (false).
 * @emit has-rendered - Emitted when the tab is active and rendered.
 */

const props = defineProps({
  title: {
    type: String,
    default: 'EnTab',
  },
  onlyRenderWhenActive: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['has-rendered']);
const isActive = ref(false);
const renderWhenNotActive = computed(() => !props.onlyRenderWhenActive);

watch(isActive, (val) => {
  if (val) {
    emit('has-rendered');
  }
});
defineExpose({
  isActive,
  title: props.title,
});
</script>

<style lang="scss" scoped>

</style>
